import {getLinkPath} from 'app/utils/link_helper';
import {isHiddenTemple} from 'app/utils/articles/isHiddenTemple';

export const urlName = function(type: string): string {
    if (isHiddenTemple(type)) {
        return getLinkPath(`/news/${type}`);
    }
    return getLinkPath(`/${type}`);
};
